import { useEffect, useState } from "react";
import { SmartSoftButton, SmartTable, SmartTableNewInterface } from "soft_digi";
import { USERS_URLS } from "../../api/UserUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showNotification, showYesOrNoAlert } from "../../services/notifyService";
import { get, post } from "../../services/smartApiService";
import UsersForm from "./UsersForm";


const UsersTable = ({dataIn}: any) => {
  const [data, setData] = useState([]);
  const { setLoading, openModal } = useSiteContext();

  const loadTableData = (purpose = "") => {
    setLoading(true, purpose && purpose + "ing...");
    const subscription = get(USERS_URLS.GET_ALL).subscribe((response) => {
      setData(response.data.data);
      purpose
        ? setTimeout(() => setLoading(false), 800)
        : setLoading(false);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    if(dataIn) {
      return setData(dataIn)
    }
    loadTableData();
  }, []);

  const getValue = (value: any) => {
    const val = !value || value.length < 1 ? <div className="pl-6">-</div> : value;
    return val
  }

  const UserEdit = (id: any) => {
    setLoading(true);
    const subscription = post(USERS_URLS.GET_ONE, { id: id }).subscribe((response) => {
      setLoading(false);
      userCreation(response.data.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const userCreation = (data_in: any) => {
    let modalObject = {
      title: "USER FORM",      
      content: <UsersForm dataIn={data_in} loadData={loadTableData} />,
      className: "smart-modal-80",
    };
    openModal(modalObject);
  };

  const deleteUser = (id: any) => {
    showYesOrNoAlert("Do you want to Delete User", (result: any) => {
      if (result == "yes") {
        send_delete_request(id);
      }
    }, "info");
  };

  const send_delete_request = (id: any) => {
    setLoading(true, "Deleting...");
    const subscription = post(USERS_URLS.DELETE, { id: id }).subscribe((response) => {
      setLoading(false);
      showNotification("success", "Deleted Successfully");
      loadTableData();
    }
    );
    return () => {
      subscription.unsubscribe();
    };
  }

  const pwReset = (id: any) => {
    showYesOrNoAlert("Do you want to Reset the Password", (result: any) => {
      if (result == "yes") {
        sent_pwreset_requset(id);
      }
    }, "info");
  }

  const sent_pwreset_requset = (id: any) => {
    setLoading(true);
    const subscription = post(USERS_URLS.PASS_RESET, { id: id }).subscribe((response) => {
      setLoading(false);
      // openEditModal(response.data);      
      showNotification("success", `Password Reset for "${response.data.data.ename}" Successfully`)
      loadTableData()
    });
    return () => {
      subscription.unsubscribe();
    };
  }

  //active api request
  const activeUser = (obj: any) => {
    const active_status = obj["active_status"];
    const req_msg = active_status == 0 ? "Active" : "Deactive"
    const change_status = active_status == 0 ? 5 : 0

    showYesOrNoAlert(`Do you want to ${req_msg} "${obj["ename"]}"`, (result: any) => {
      if (result == "yes") {
        sent_active_requset(obj["ID"], change_status);
      }
    }, "info");
  }

  const sent_active_requset = (id: any, change_status: any) => {
    setLoading(true);
    const subscription = post(USERS_URLS.UPDATE_STATUS, { id: id, active_status: change_status }).subscribe((response) => {
      setLoading(false);
      showNotification("success", `Activated "${response.data.data.ename}" Successfully`)
      loadTableData()
    });
    return () => {
      subscription.unsubscribe();
    };
  }


  const getRoles = (obj: any) => {
    const roles = obj["roles"];
    if (roles.length < 1) return <div className="pl-6">-</div>
    const tooltipClass = "tooltip has-tooltip-top"
    if (!Array.isArray(roles)) return roles;

    return roles.map((role, index) => {
      if (index < 3) {
        return (
          <>
            <span data-tooltip={roles.join(" | ")} className={tooltipClass}>{role}</span>
            {index < 2 && <span>{", "}</span>}
            {index == 2 && roles.length > 3 && <span>...</span>}
          </>
        )
      }
    })
  }

  const getStatus = (obj: any) => {
    let active_status = obj["active_status"];
    if (active_status.length < 1) return <div className="pl-6">-</div>
    return (
      <>
        {active_status == 5 && <span className="tag is-success is-light">Active</span>}
        {active_status == 0 && <span className="tag is-danger is-light">Deactive</span>}
      </>
    );
  };


  const actionButtons = [
    {
      leftIcon: "fa-pencil", 
      type:"icon",
      classList:["has-text-link"],      
      onClick:(row:any)=> UserEdit(row["ID"])
    },
    {
      leftIcon: "fa-trash", 
      type:"icon",
      classList:["has-text-danger"],      
      onClick:(row:any)=> deleteUser(row["ID"])
    },
    {
      leftIcon: "fa-key", 
      type:"icon",
      classList:["has-text-warning"],      
      onClick:(row:any)=> pwReset(row["ID"])
    },
    {
      leftIcon: "fa-lock-open", 
      type:"icon",
      classList:["has-text-success"],      
      onClick:(row:any)=> activeUser(row)
    },
    {
      leftIcon: "fa-lock", 
      type:"icon",
      classList:["has-text-danger"],      
      onClick:(row:any)=> activeUser(row)
    }
  ]

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "EMPLOYEE ID", index: "euserid", valueFunction: (obj) => getValue(obj["euserid"]) },
    { title: "EMPLOYEE NAME", index: "ename", valueFunction: (obj) => getValue(obj["ename"]) },
    { title: "EMAIL ID", index: "emailid", valueFunction: (obj) => getValue(obj["emailid"]) },
    { title: "EMP ROLE", index: "roles", valueFunction: getRoles },
    { title: "DSC DETAILS", index: "dsc_details", valueFunction: (obj) => getValue(obj["dsc_details"]) },
    { title: "STATUS", index: "active_status", valueFunction: getStatus, classHead: "has-text-centered", classBody: "has-text-centered" },
    { title: "", index: "action", type:"action", width: "5", buttons:actionButtons },
  ];

  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: <p className="has-text-link is-size-4">Users</p>,
     
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "RIGHT",
    },   
    {
      type: "CUSTOM",
      widthClass: "is-2",
      align:"RIGHT",
      custom: 
        <div className="buttons mx-3">
          <SmartSoftButton 
            label="New User"
            onClick={()=>userCreation(null)} 
            leftIcon="fa-plus" 
            classList={["smart-third-button"]}         
            />        
        </div>
    },

  ]


  return (
    <div className="shadow my-4">
      <SmartTable
        tableTop={tableTop}
        columns={columns}
        data={data}
        tableProps={{
          className: "table is-hoverable is-striped smart-pdf-table",
          isResponsive: true,
          searchIndexes: ["ename", "emailid"],
          searchPlaceHolder: "Search Users",
        }} />
    </div>
  );
};

export default UsersTable;
